import classNames from 'classnames';
import { getDefaultClassNames } from 'react-day-picker';

import styles from '../ui/DateRangePicker.module.css';

const rdpDefaultClassNames = getDefaultClassNames();

const dayPickerClassNames = {
  months: classNames(rdpDefaultClassNames.months, styles.months),
  month: classNames(rdpDefaultClassNames.month, styles.month),
  month_caption: classNames(rdpDefaultClassNames.month_caption, styles.monthCaption),
  month_grid: classNames(rdpDefaultClassNames.month_grid, styles.monthGrid),
  weekday: classNames(rdpDefaultClassNames.weekday, styles.weekday),
  button_previous: classNames(rdpDefaultClassNames.button_previous, styles.navButton, styles.navButtonPrevious),
  button_next: classNames(rdpDefaultClassNames.button_next, styles.navButton, styles.navButtonNext),
  chevron: styles.navChevron,
  dropdowns: classNames(rdpDefaultClassNames.dropdowns, styles.dropdowns),
  dropdown_root: classNames(rdpDefaultClassNames.dropdown_root, styles.dropdownRoot),
  dropdown: classNames(rdpDefaultClassNames.dropdown, styles.dropdown),
  caption_label: classNames(rdpDefaultClassNames.caption_label, styles.captionLabel),
};

export default dayPickerClassNames;
